export const FuelType = {
  None: 0,
  Gas: 1,
  Diesel: 2,
  Hybrid: 3,
  Electric: 4,
  FlexFuel: 5,
  Hydrogen: 6,
}

export const FuelTypes = [
  { label: 'Gas', value: FuelType.Gas },
  { label: 'Diesel', value: FuelType.Diesel },
  { label: 'Hybrid', value: FuelType.Hybrid },
  { label: 'Electric', value: FuelType.Electric },
  { label: 'Flex Fuel', value: FuelType.FlexFuel },
  { label: 'Hydrogen', value: FuelType.Hydrogen },
]

export const NormalizedFuelTypes = {
  1: 'Gas',
  2: 'Diesel',
  3: 'Hybrid',
  4: 'Electric',
  5: 'FlexFuel',
  6: 'Hydrogen',
}
